import React from 'react';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useReportTypes, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const ReportTypesPage = () => (
  <DynamicCrudPage
    entityType="reportTypes"
    hook={useReportTypes}
    additionalHooks={{
      companies: useCompanies,
    }}
    addButtonTextKey="table.actions.addReportType"
    addButtonIcon={<AddIcon />}
    entityTypeForDataTable="reportType"
  />
);

export default ReportTypesPage;
